import { BaseSuperAgentRequestFactory, RequestSender } from '@studyportals/mb-platform-http-requests/base';
import { IVisa, VisaInformationClientRead } from '@studyportals/visa-information-interface/';
import { Visa } from './Visa';
import { Country } from './Country';

class VisaPresenter {
	private readonly client: VisaInformationClientRead;

	public constructor() {
		this.client = new VisaInformationClientRead(
			CONFIG.VISA_INFORMATION_URL,
			new BaseSuperAgentRequestFactory(),
			new RequestSender()
		);
	}

	public async retrieve(idOfOriginCountry: string, idOfDestinationCountry: string): Promise<Visa | null> {
		if (idOfOriginCountry === idOfDestinationCountry) {
			return Visa.sameCountry(idOfOriginCountry);
		}

		const visas = await this.client.getByDestinationCountryForOrigin(idOfDestinationCountry, idOfOriginCountry);
		if (visas.length === 0) {
			return null;
		}

		return this.reconstitute(visas[0]);
	}

	private reconstitute(source: IVisa): Visa {
		return new Visa(
			new Country(source.destinationCountryId),
			new Country(source.originCountryId),
			source.isVisaRequired,
			source.visaName,
			source.visaDuration ?? null,
			source.visaFeeCurrencyIso ?? null,
			source.visaFeeAmount ?? null,
			source.applicationDescription ?? null,
			source.applicationLink ?? null,
			source.requiresProofOfLanguage ?? null,
			source.requiresInterview ?? null,
			source.requiresMedicalExam ?? null,
			source.requiresProofOfFunds ?? null,
			source.proofOfFundsDescription ?? null,
			source.requiresBlockedBankAccount ?? null,
			source.otherInformation ?? null,
			source.originCountryDemonym ?? null,
			source.records ?? null,
			source.sourceLink ?? null,
			source.mayRequireInterview ?? null,
			source.requiresTravelAbroad ?? null,
			source.travelAbroadDescription ?? null,
			source.requiresBiometrics ?? null,
			source.requiresCriminalRecordsCheck ?? null,
			source.requiresProofOfAccommodation ?? null,
			source.requiresHealthInsurance ?? null,
			source.healthInsuranceDescription ?? null,
			source.otherExpenses ?? null
		);
	}
}

const visaPresenter = new VisaPresenter();
export { visaPresenter as VisaPresenter };
